var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoTrustedCompanies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "30px",
    viewBox: "0 0 33 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "comp copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1145.000000, -731.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "comp-copy-5",
    transform: "translate(1145.000000, 732.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "26 17.9101563 26 0.0544433594 9.01660156 0.0544433594 9.01660156 23.9993896 21.2980957 23.9993896"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fillRule: "nonzero",
    x: 1,
    y: 8,
    width: 8,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,4.5 L22,4.5",
    id: "Path-38",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,8.5 L22,8.5",
    id: "Path-38",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,12.5 L22.0140381,12.5",
    id: "Path-38",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,29 C22.1340068,29 19,25.8659932 19,22 C19,18.1340068 22.1340068,15 26,15 C29.8659932,15 33,18.1340068 33,22 C33,25.8659932 29.8659932,29 26,29 Z M26.3328304,24.4933881 L30.8852186,19.9142136 L29.471005,18.5 L24.9248477,23.072907 L22.4142136,20.5399865 L21,21.9542 L24.9321428,25.9212476 L26.3463563,24.507034 L26.3328304,24.4933881 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTrustedCompanies);
export default __webpack_public_path__ + "static/media/ico_trusted-companies.9f26a95b199a44ba7449a1db72027936.svg";
export { ForwardRef as ReactComponent };